import React from 'react';
import { Layout } from 'antd';
import Logos from '../common/Logos';
import { useTranslation } from 'react-i18next';

const { Footer, Content } = Layout;

const contentStyle: React.CSSProperties = {
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    minHeight: 0,
    padding: 'clamp(12px, 3vh, 28px) 24px',
};

const footerStyle: React.CSSProperties = {
    alignItems: 'center',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 24px clamp(14px, 3vh, 28px)',
};

const projectPeriodStyle: React.CSSProperties = {
    color: 'rgba(31, 42, 61, 0.72)',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.2,
};

const layoutStyle: React.CSSProperties = {
    backgroundColor: '#f4f7fc',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1400px',
    minHeight: '100vh',
    padding: 0,
};

const LoginLayout = ({ children }) => {
    const { t } = useTranslation();

    return (
        <Layout style={layoutStyle}>
            <Logos />
            <Content style={contentStyle}>{children}</Content>
            <Footer style={footerStyle}>
                <span style={projectPeriodStyle}>{t('login.projectPeriod')}</span>
            </Footer>
        </Layout>
    );
};

export default LoginLayout;
